export default __webpack_public_path__ + "static/media/papagei.486c19c4.png";